var classes = {"imageActionRoot":"-otTW"};

export { classes as default };
